import { HStack } from "@chakra-ui/react";

import { MobileOnly } from "components/BreakpointVisibility";
import { RequestContractFormLineItem } from "forms/RequestContractForm";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import StatHeading from "./StatHeading";
import StatText from "./StatText";

const LINE_ITEM_WIDTH = mobileStyleBreakpoint("100%", "25%");

const LineItemValue = ({ label, value }: { label: string; value?: string }) => (
  <HStack spacing={0} w={LINE_ITEM_WIDTH}>
    <MobileOnly>
      <StatHeading>{label}</StatHeading>
    </MobileOnly>
    <StatText>{value}</StatText>
  </HStack>
);

const LineItem = ({ lineItem }: { lineItem: RequestContractFormLineItem }) => (
  <>
    <LineItemValue label="Ship From" value={lineItem.shipFrom?.label} />
    <LineItemValue label="Ship To" value={lineItem.shipTo?.label} />
    <LineItemValue label="Mode" value={lineItem.mode?.label} />
    <LineItemValue label="Sales Terms" value={lineItem.salesTerms?.label} />
  </>
);

export default LineItem;
